// eslint-disable-next-line import/prefer-default-export
export const NO_OPTIONS_MESSAGE = 'No data available';
